import React from 'react';
import {useLocation} from 'react-router-dom';

import {theme} from '../constants';
import {components} from '../components';

export const Description: React.FC = () => {
  const location = useLocation();
  const item = location.state.item;

  const renderHeader = () => {
    return <components.Header goBack={true} title='توضیحات' />;
  };
  const hadleTitlePersian = (value: string): string => {
    if (value === 'FlexFit Training Shoes') {
      return 'کفش تمرینی فِلِکس‌فیت';
    } else if (value === 'Seeker Hiking Boots') {
      return 'بوت کوهنوردی سیکر';
    } else if (value === 'Dapper Derby Shoes') {
      return 'کفش دربی شیک';
    } else if (value === 'Urban Charm Sneakers') {
      return 'کتانی جذاب شهری';
    } else if (value === 'Seeker Hiking Bootss') {
      return 'بوت کوهنوردی سیکر';
    } else {
      return 'عنوان نامشخص';
    }
  };
  const renderContent = () => {
    return (
      <div style={{padding: '30px 20px 20px 20px'}}>
        <h3
          style={{
            margin: 0,
            marginBottom: 14,
            ...theme.fonts.Mulish_700Bold,
            fontWeight: 700,
            fontSize: 20,
            lineHeight: 1.2,
            color: theme.colors.mainColor,
          }}
        >
          {hadleTitlePersian(item.name)}
        </h3>
        <p
          style={{
            margin: 0,
            ...theme.fonts.Mulish_400Regular,
            fontSize: 16,
            color: theme.colors.textColor,
            lineHeight: 1.7,
          }}
        >
          آماده باش تا سطح تمرینات خود را با کفش‌های تمرینی FlexFit ما ارتقا
          دهی. این کفش‌ها برای عملکرد حداکثری و راحتی مهندسی شده‌اند و طراحی
          شده‌اند تا در تمام طول تمرینات از شما پشتیبانی کنند...
        </p>
      </div>
    );
  };

  return (
    <>
      {renderHeader()}
      {renderContent()}
    </>
  );
};
